module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-152x152-precomposed-f17b47dac10457bff8547abf1b8cb52d.png";